import React from "react";
import "chartjs-plugin-datalabels";
import { Bar } from "react-chartjs-2";
import { Chart, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { commonColors } from "./data";

Chart.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);


const BarchartGraph = ({ graphData, isChecked, lang }) => {
  const options = {
    indexAxis: "y" as const,

    elements: {
      bar: {
        borderWidth: 1,
      },
    },

    responsive: true,
    maintainAspectRatio: false,

    plugins: {
      datalabels: {
        color: "#fff",
        formatter: (value, context) => {
          return Math.round(context.dataset.labels[context.dataIndex]);
        },
      },
      legend: {
        display: false,
      },
      title: {
        display: false,
      },

      tooltip: {
        enabled: false,
      },
    },
  };

  const greenColors = graphData?.colors?.filter((color) => color === commonColors["green"]);
  Chart.defaults.datasets.bar.barThickness = 15;

  const data = {
    labels: isChecked ? graphData?.verticalAxisLabel : graphData?.verticalAxisLabelGreen,
    datasets: [
      {
        data: isChecked ? graphData?.verticalAxisData : graphData?.greenColorValues,
        borderColor: isChecked ? graphData?.colors : greenColors,
        backgroundColor: isChecked ? graphData?.colors : greenColors,
        labels: isChecked ? graphData?.verticalAxisData : graphData?.greenColorValues,
      },
    ],
  };

  return <Bar data={data} plugins={[ChartDataLabels]} options={options} />;
};

export default BarchartGraph;
